import logger from "@next/core-logger"
import {Action, Store} from "@reduxjs/toolkit"
import {HeaderModel} from "../../models/headerModel"
import {getHeaderData} from "../../api/headerdata"
import {SupportedRegionTypes} from "../../models/regions"
import {setTabbedNavigationEnabled} from "../settings"
import isSecurePageRequested from "../../utils/secureHeader"
import {SECURE_HEADER_VARIANT} from "../../config/constants"

export const SET_HEADER_DATA = "SET_HEADER_DATA"

interface SetHeaderData {
    type: typeof SET_HEADER_DATA
    data: HeaderModel
}

export type HeaderDuckState = HeaderModel | null

const initialState: HeaderDuckState = null

const setHeaderDataAction = (data: HeaderModel) => {
    return {
        type: SET_HEADER_DATA,
        data,
    }
}

export const getHeaderDataThunk = async ({dispatch, getState}: Store, defaultHeaderVersion: string) => {
    try {
        const {
            request: {headers, url},
            settings: {variant, secureHeaderEnabled},
        } = getState()
        const localVariant =
            isSecurePageRequested(url) && secureHeaderEnabled ? `${SECURE_HEADER_VARIANT}-${variant}` : variant
        const response = await getHeaderData(headers, defaultHeaderVersion, localVariant)
        if (!response.regions.find(region => region.type === SupportedRegionTypes.TabbedDepartment)) {
            dispatch<Action>(setTabbedNavigationEnabled(false))
        }
        dispatch<Action>(setHeaderDataAction(response))
    } catch (error) {
        logger.error(error)
        dispatch(setHeaderDataAction(new HeaderModel()))
    }
}

const reducer = (state: HeaderDuckState = initialState, action: SetHeaderData): HeaderDuckState => {
    const {data} = action

    switch (action.type) {
        case SET_HEADER_DATA:
            return {
                ...state,
                ...data,
            }
        default:
            return state
    }
}

export default reducer
